import { ChangeDetectionStrategy, Component, computed, inject, signal, viewChild } from '@angular/core'
import { RouterLink } from '@angular/router'
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay'

import { ActiveRoute, AppStore } from '@core/index'
import { getVisibleNavItems } from '@layout/nav-items'
import { IconApp } from '@shared/components'
import { Clicks } from '@shared/directives'
import { ExtrasDropdown } from '@layout/components/extras-dropdown/extras-dropdown'

@Component({
  selector: 'mobile-menu',
  imports: [IconApp, RouterLink, CdkOverlayOrigin, CdkConnectedOverlay, ExtrasDropdown, Clicks],
  templateUrl: './mobile-menu.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'fixed bottom-0 left-0 right-0 z-20 md:hidden'
  }
})
export class MobileMenu {
  #appStore = inject(AppStore)
  #activeRoute = inject(ActiveRoute)

  navItems = computed(() => getVisibleNavItems(this.#appStore.currentUser()?.userType))
  isOpen = signal(false)
  trigger = viewChild(CdkOverlayOrigin)

  currentUrl = this.#activeRoute.currentUrl

  isActive(route: string): boolean {
    return this.#activeRoute.isActive(route)
  }
}
